<template>
  <header>
    <div class="breadcrumb" aria-label="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right" v-if="isTopologymapMenu">
        <el-breadcrumb-item v-for="item in navigationPath" :key="item.key">
          <a v-if="item.type === 'node'" @click="onMapNavigationPathClick(item)">{{ item.label }}</a>
          <span v-else>{{ item.label }}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else>
        <el-breadcrumb-item v-for="item in navigationPath" :key="item.key">{{ item.label }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="utility-menu">
      <ul>
        <li style="width:80px">
          <!-- 190930 ie 틀어짐 수정 -->
          <el-dropdown trigger="click" @command="clickToolList" style="margin-top:2px;" size="medium">
            <el-button style="height:26px;"> 관리 도구<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="tool in manageTools" :key="tool.command" :command="tool.command">{{ tool.label }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li>
          <el-tooltip content="WatchAll Smart Search" placement="bottom">
            <i class="tool-icon fa fa-search" style="font-size:15px;" @click="openSmartSearchPopup"></i>
          </el-tooltip>
        </li>
        <li v-show="predictEventCount > 0" :style="{ marginRight: predictEventCount > 99 ? '4px' : '0' }">
          <w-predict-event-popover @totalPredictEvent="totalPredictEvent" />
        </li>
        <li :style="{ marginRight: eventCount > 99 ? '4px' : '0' }">
          <w-event-popover @count-change="onEventCountChange" />
        </li>
        <li>
          <el-tooltip content="즐겨찾기" placement="bottom">
            <i class="tool-icon fas fa-bookmark r-top" @click="toggleBookmarkSlidingPopup"></i>
          </el-tooltip>
        </li>
        <li>
          <el-tooltip content="사용자 정보" placement="bottom">
            <i class="tool-icon fas fa-user r-top" @click="toggleUserSlidingPopup"></i>
          </el-tooltip>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import isEqual from 'lodash/isEqual';
import { applicationLauncher } from '@/utils/applauncher';
import { closeOpenFramePopup } from '@/utils/popup';
import { menuDefine } from '@/constants/menu';
import WUserSlidingPopup from './popup/UserSlidingPopup';
import WEventPopover from './popup/EventPopover';
import WPredictEventPopover from './popup/PredictEventPopover';

export default {
  name: 'WFrameHeader',
  components: {
    WUserSlidingPopup,
    WEventPopover,
    WPredictEventPopover,
  },
  data() {
    return {
      /**
       * 이벤트 개수
       * 배지에 표시되는 글자 수에 따라 옆에 아이콘과 거리 조정을 위해 관리함.
       * @type {String}
       */
      eventCount: 0,
      predictEventCount: 0,
      manageTools: [
        {
          command: 'PING',
          label: 'Ping',
        },
        {
          command: 'TTERMPRO',
          label: 'SSH/Telnet',
        },
        {
          command: 'MSTSC',
          label: '원격 데스크톱',
        },
        {
          command: 'IP_SCAN',
          label: 'IP 스캔',
        },
        {
          command: 'MIB_BROWSER',
          label: 'MIB 브라우저',
        },
        {
          command: 'NET_STAT',
          label: 'Net State',
        },
        // { command: 'ORIGIN_DATA', label: '원본 데이터' },
      ],
    };
  },
  computed: {
    navigationPath() {
      return this.$store.getters.navigationPath;
    },
    /**
     * 로그인한 계정 정보
     * @author Ju
     * @return {[type]} [description]
     */
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isTopologymapMenu() {
      return this.$store.getters.selectedMenu && this.$store.getters.selectedMenu.url === menuDefine.TOPOLOGYMAP;
    },
  },
  methods: {
    clickToolList(tool) {
      if (isEqual(tool, 'IP_SCAN')) {
        applicationLauncher().openIpScanPopup();
      } else if (isEqual(tool, 'MIB_BROWSER')) {
        applicationLauncher().openMibBrowserPopup();
      } else if (isEqual(tool, 'ORIGIN_DATA')) {
        // TODO: 기능 추가 핖요
      } else {
        this.excuteLauncher(tool);
      }
    },
    /**
     * 사용자 정보 슬라이딩 팝업을 제공한다.
     * @author Ju
     */
    toggleUserSlidingPopup() {
      if (this.$store.state.popup.showUserPopup) {
        this.$store.dispatch('closeUserPopup');
      } else {
        this.$store.dispatch('openUserPopup');
      }
    },
    totalPredictEvent(total) {
      this.predictEventCount = total;
    },
    excuteLauncher(exectype) {
      const executeType = exectype;
      applicationLauncher().directExecute(executeType, null, this);
    },
    onMapNavigationPathClick(item) {
      if (!item.data.auth) {
        this.$message.info('접근 권한이 없습니다');
      } else {
        this.$router.push({
          path: `/topologymap/${item.data.treeKey}`,
          params: {
            treeKey: item.data.treeKey,
          },
        });
      }
    },
    /**
     * 즐겨찾기 팝업을 연다.
     */
    toggleBookmarkSlidingPopup() {
      if (this.$store.state.popup.showFavoritePopup) {
        this.$store.dispatch('closeFavoritePopup');
      } else {
        this.$store.dispatch('openFavoritePopup');
      }
    },
    /**
     * 실시간 이벤트 개수 변경 이벤트 핸들러
     * @author Ju
     */
    onEventCountChange(count) {
      this.eventCount = count;
    },
    /**
     * 스마트 검색 팝업을 연다.
     * @author Ju
     */
    openSmartSearchPopup() {
      if (this.$store.state.popup.showSmartSearchPopup) {
        closeOpenFramePopup();
      } else {
        this.$store.dispatch('openSmartSearchPopup');
      }
    },
  },
};
</script>

<style scoped>
.el-dropdown-menu--mini {
  padding: 7px 0;
}

.el-dropdown-menu--mini .el-dropdown-menu__item {
  line-height: 25px;
  padding: 0px 15px;
  font-size: 13px;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #ecf5ff;
  color: #0041ce;
}
</style>



// WEBPACK FOOTER //
// src/views/frame/components/FrameHeader.vue